import React from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Divider,
  Drawer,
} from "@mui/material";
import { Filter } from "lucide-react";

const ProductFilters = ({
  filters,
  isMobile,
  mobileFiltersOpen,
  setMobileFiltersOpen,
  onFilterChange,
  selectedProperties,
}) => {
  if (filters?.length === 0) return;
  if (isMobile) {
    return (
      <div className="text-left p-5 ps-[6%]">
        <button
          onClick={() => setMobileFiltersOpen(true)}
          className="border cursor-pointer py-1 px-3 rounded-lg flex items-center gap-2 text-sm"
        >
          <Filter size={15} /> Filters
        </button>

        <Drawer
          anchor="left"
          open={mobileFiltersOpen}
          onClose={() => setMobileFiltersOpen(false)}
        >
          <Box sx={{ width: 260 }}>
            <RenderFilters
              filters={filters}
              onFilterChange={onFilterChange}
              selectedProperties={selectedProperties}
            />
          </Box>
        </Drawer>
      </div>
    );
  }

  return (
    <div
      className="border-r h-screen overflow-auto"
      style={{ width: 300, flexShrink: 0 }}
    >
      <RenderFilters
        onFilterChange={onFilterChange}
        filters={filters}
        selectedProperties={selectedProperties}
      />
    </div>
  );
};

export default ProductFilters;

const RenderFilters = ({ onFilterChange, filters, selectedProperties }) => {
  const handleCheckboxChange = (category, itemCode, checked) => {
    onFilterChange(category, itemCode, checked);
  };

  return (
    <Box sx={{ p: 2, fontFamily: "Inter, sans-serif" }}>
      {filters.length > 0 &&
        filters.map((category, i) => (
          <Box key={i} sx={{ mb: 3 }}>
            <Typography
              variant="h6"
              sx={{ color: "#222", mb: 1, fontSize: "16px" }}
            >
              {category.printable_name}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Box>
              {category.product_property_value_all.map((item, index) => {
                const isChecked = selectedProperties.includes(item.id); // ✅ check if selected
                return (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        size="small"
                        checked={isChecked} // ✅ maintain checked state
                        onChange={(e) =>
                          handleCheckboxChange(
                            category.printable_name,
                            item.id,
                            e.target.checked,
                          )
                        }
                        sx={{
                          color: "#666",
                          "&.Mui-checked": {
                            color: "#000",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "14px",
                          color: "#444",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name}
                      </Typography>
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  />
                );
              })}
            </Box>
          </Box>
        ))}
    </Box>
  );
};
